module.exports = __webpack_public_path__ + "static/media/fuel.0090e35c.svg";